import React from 'react'

import { StringText } from '@/Atomic/Atoms/StringText'
import InfoBox from '@/Atomic/Molecules/InfoBox'
import { Modal } from '@/Atomic/Organisms/Modal'
import { useOnEscPress } from '@/hooks/useOnEscPress'

interface ConfirmationModalProps {
  isOpen: boolean
  close: () => void
  confirm: () => void
  variant?: 'info' | 'success' | 'danger' | 'warning'
  confirmationButtonText?: string
  cancelButtonText?: string
  title: string
  subtitle: string
}
export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  close,
  confirm,
  variant = 'info',
  confirmationButtonText,
  cancelButtonText,
  title,
  subtitle,
}) => {
  useOnEscPress({ onEscPress: close })
  const modalVariant = variant == 'danger' ? 'danger' : 'default'

  return (
    <Modal isOpen={isOpen} onClose={close} variant={modalVariant}>
      <Modal.Header title={title} />
      <Modal.Body>
        <InfoBox type={variant}>
          <StringText value={subtitle} />
        </InfoBox>
      </Modal.Body>
      <Modal.Footer
        onConfirmText={confirmationButtonText}
        onCancelText={cancelButtonText}
        onConfirm={confirm}
        onCancel={close}
      ></Modal.Footer>
    </Modal>
  )
}
